import Cross from "../../../assets/icon/NewsIcons/MainAdmin/NewsCross"
import React, { useState, useEffect, useRef } from "react";
import { axiosReq } from "../../../commons/axiosReq";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Select from "react-select";

const AddModalAdmin = ({ setShowModal, title, buttonName,
     setRecheck, reCheck, data
     , setSettingModal,setData }) => {
    let navigate = useNavigate();
    const [snipper, setSnipper] = useState(false);
    const [showErrorModalStep1,
        setShowErrorModalStep1] = useState(false);
    const [error, setEroor] = useState();

    const [roleOptions, setRoleOptions] = useState([]);
    const [positionOptions, setPositionOptions] = useState([]);
    const [selectedRole, setSelectedRole] = useState(
        data?.userRoleTitle ? { value: data.userRoleTitle, label: data.userRoleTitle } : null
    );
    const [selectedPosition, setSelectedPosition] = useState(
        data?.userPositionTitle ? { value: data.userPositionTitle, label: data.userPositionTitle } : null
    );
    const [roleInput, setRoleInput] = useState(data?.userRoleTitle || '');
    const [positionInput, setPositionInput] = useState(data?.userPositionTitle || '');

    const [allValues, setAllValues] = useState({
        IsAdmin: data ? data.isAdmin : false,
        Name: data ? data.name : '',
        Family: data ? data.family : '',
        Username: data ? data.email : '',
        Password: data ? data.password : ''
    });
    const [allValuesError, setAllValuesError] = useState({
        Name: false,
        Family: false,
        Username: false,
        Password: false
    });

    useEffect(() => {
        const fetchRolesAndPositions = async () => {
            const [rolesRes, positionsRes] = await Promise.all([
                axiosReq("user/GetAllRoles", "get"),
                axiosReq("user/GetAllPositions", "get"),
            ]);
            if (rolesRes?.data) {
                setRoleOptions(rolesRes.data.map(r => ({ value: r.title, label: r.title })));
            }
            if (positionsRes?.data) {
                setPositionOptions(positionsRes.data.map(p => ({ value: p.title, label: p.title })));
            }
        };
        fetchRolesAndPositions();
    }, []);

    const blurHandler = e => {
        if (e.target) {
            if (e.target.value == "") {
                setAllValuesError({ ...allValuesError, [e.target.name]: true })
            }
        }
    }
    const changeHandler = e => {
        if (e.target) {
            if (e.target.value != "") {
                setAllValuesError({ ...allValuesError, [e.target.name]: false })
            }
            else {
                setAllValuesError({ ...allValuesError, [e.target.name]: true })
            }
            setAllValues({ ...allValues, [e.target.name]: e.target.value })
        }
    }
    const handleKeyDown = (e) => {
        if (e.code === "Enter") {
            addAdmin();
        }
    };

    // For role: merge typed text with selected option
    const handleRoleInputChange = (inputValue) => {
        setRoleInput(inputValue);
    };
    const handleRoleChange = (option) => {
        setSelectedRole(option);
        setRoleInput(option ? option.value : '');
    };

    // For position
    const handlePositionInputChange = (inputValue) => {
        setPositionInput(inputValue);
    };
    const handlePositionChange = (option) => {
        setSelectedPosition(option);
        setPositionInput(option ? option.value : '');
    };

    // Get current role/position title (typed or selected)
    const getRoleTitle = () => {
        if (roleInput && roleInput.trim() !== '') return roleInput.trim();
        if (selectedRole) return selectedRole.value;
        return null;
    };
    const getPositionTitle = () => {
        if (positionInput && positionInput.trim() !== '') return positionInput.trim();
        if (selectedPosition) return selectedPosition.value;
        return null;
    };

    const addAdmin = async () => {
        let check = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;
        setSnipper(true)

        if (!allValues.Password.match(check)) {
            setAllValuesError({ ...allValuesError, Password: true })
        } else {
            var res = allFull(allValues)
            if (res) {
                const dataUser = await axiosReq("user/InsertUser", "post", {
                    IsAdmin: allValues?.IsAdmin,
                    Name: allValues?.Name,
                    Family: allValues?.Family,
                    Email: allValues?.Username,
                    Password: allValues?.Password,
                    RoleTitle: getRoleTitle(),
                    PositionTitle: getPositionTitle(),
                });
                if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {
                    setRecheck(!reCheck)
                    setShowModal(false)
                    setData(dataUser?.data)
                    alert("موفقیت آمیز");
                } else {
                    setEroor(dataUser?.data)
                    setShowErrorModalStep1(true);
                }
            } else {
                setEroor("لطفا موارد خواسته شده را وارد نمایید")
                setShowErrorModalStep1(true);
            }
        }
    }

    const editAdmin = async () => {
        let check = /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;
        setSnipper(true)

        if (!allValues.Password.match(check)) {
            setAllValuesError({ ...allValuesError, Password: true })
        }
        setSnipper(true)
        var res = allFull(allValues)
        if (res) {
            const dataUser = await axiosReq("user/UpdateUser", "put", {
                UserId: data?.adminId,
                IsAdmin: allValues?.IsAdmin,
                Name: allValues?.Name,
                Family: allValues?.Family,
                Email: allValues?.Username,
                Password: allValues?.Password,
                RoleTitle: getRoleTitle(),
                PositionTitle: getPositionTitle(),
            });
            if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {
                setRecheck(!reCheck)
                alert("موفقیت آمیز");
                setShowModal(false)
            } else {
                setEroor(dataUser.data);
                setShowErrorModalStep1(true);
            }
        } else {
            setEroor("لطفا موارد خواسته شده را وارد نمایید")
            setShowErrorModalStep1(true);
        }
    }

    const allFull = (obj) => {
        const updatedState = {};
        var result = true;
        for (var o in obj) {
            if (obj[o] == "" && o!="IsAdmin") {
                updatedState[o] = true;
                setAllValuesError({ ...allValuesError, ...updatedState })
                result = false;
            }
        }
        return result
    }

    const maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
    }

    const selectStyles = {
        control: (base) => ({
            ...base,
            minHeight: '35px',
            height: '35px',
            fontSize: '12px',
            borderColor: '#e2e8f0',
            borderRadius: '5px',
        }),
        valueContainer: (base) => ({ ...base, padding: '0 10px' }),
        input: (base) => ({ ...base, margin: 0, padding: 0 }),
        indicatorsContainer: (base) => ({ ...base, height: '35px' }),
        menu: (base) => ({ ...base, fontSize: '12px', zIndex: 9999 }),
    };

    return (
        <>
            <div
                className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
            >
                <div className="relative w-[50%] my-5 mx-auto ">

                    <div className="border-0 rounded-[20px] p-[25px] shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        <div className="flex justify-between items-center border-b-2 pb-[25px] border-borderGray">
                            <p className="text-[15px] font-IRANYekanBold text-mainColor2">{title}</p>
                            <button onClick={() => setShowModal(false)}><Cross /></button>
                        </div>
                        <div className="grid grid-cols-2 gap-2 w-full mt-[23px] mb-[43px]">
                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">نام</span>
                                <input
                                    onChange={changeHandler}
                                    onBlur={blurHandler}
                                    name="Name"
                                    placeholder="نام را اینجا بنویسید"
                                    value={allValues?.Name}
                                    onInput={maxLengthCheck}
                                    maxLength={100}
                                    onKeyPress={(event) => {
                                        if (/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                        if (/[۱-۹]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                    className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray" type="text" />
                                   {
                                    allValuesError.Name ?
                                        <span className="flex items-center font-medium tracking-wide text-[#ff0000] text-xs  ml-1">
                                            لطفا نام را وارد نمایید !
                                        </span>
                                        :
                                        null
                                }
                            </div>
                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">نام خانوادگی</span>
                                <input
                                    className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray"
                                    type="text" placeholder="نام خانوادگی را اینجا بنویسید"
                                    onBlur={blurHandler}
                                    name="Family"
                                    onChange={changeHandler}
                                    value={allValues?.Family}
                                    onInput={maxLengthCheck}
                                    onKeyPress={(event) => {
                                        if (/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                        if (/[۱-۹]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                    maxLength={100} />
                                     {
                                    allValuesError.Family ?
                                        <span className="flex items-center font-medium tracking-wide text-[#ff0000] text-xs  ml-1">
                                            لطفا نام خانوادگی را وارد نمایید !
                                        </span>
                                        :
                                        null
                                }
                            </div>
                            <div className="col-span-1 mb-[10px]  flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">ادمین</span>
                                <input onChange={(e) => setAllValues({ ...allValues, IsAdmin: e.target.checked })} checked={allValues.IsAdmin} className="w-[15px] h-[15px]  accent-mainColor2 " type="checkbox" />
                            </div>
                          
                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">ایمیل</span>
                                <input className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray"
                                    type="text" placeholder="ایمیل را اینجا بنویسید"
                                    onBlur={blurHandler}
                                    name="Username"
                                    onChange={changeHandler}
                                    value={allValues?.Username}
                                    onInput={maxLengthCheck}
                                    maxLength={100}
                                />
                                {
                                    allValuesError.Username ?
                                        <span className="flex items-center font-medium tracking-wide text-[#ff0000] text-xs  ml-1">
                                            لطفا ایمیل را وارد نمایید !
                                        </span>
                                        :
                                        null
                                }
                            </div>
                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">رمز عبور</span>
                                <input className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray"
                                    type="password" placeholder="رمز عبور را اینجا بنویسید"
                                    onBlur={blurHandler}
                                    name="Password"
                                    onChange={changeHandler}
                                    value={allValues?.Password}
                                    onInput={maxLengthCheck}
                                    maxLength={100}
                                />
                                {
                                    allValuesError.Password ?
                                        <span className="flex items-center font-medium tracking-wide text-[#ff0000] text-xs  ml-1">
                                            رمز عبور هشت رقم و دارای حرف بزرگ و کوچک ، عدد و یکی از(.@?!*) می باشد!</span>
                                        :
                                        null
                                }
                            </div>

                            {/* Role input with autocomplete */}
                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">نقش (Role)</span>
                                <Select
                                    isClearable
                                    isSearchable
                                    placeholder="نقش را انتخاب یا تایپ کنید"
                                    options={roleOptions}
                                    value={selectedRole}
                                    inputValue={roleInput}
                                    onInputChange={handleRoleInputChange}
                                    onChange={handleRoleChange}
                                    styles={selectStyles}
                                    noOptionsMessage={() => 'موردی یافت نشد - متن تایپ شده ثبت می‌شود'}
                                    filterOption={(option, input) =>
                                        option.label.toLowerCase().includes(input.toLowerCase())
                                    }
                                />
                            </div>

                            {/* Position input with autocomplete */}
                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">پوزیشن (Position)</span>
                                <Select
                                    isClearable
                                    isSearchable
                                    placeholder="پوزیشن را انتخاب یا تایپ کنید"
                                    options={positionOptions}
                                    value={selectedPosition}
                                    inputValue={positionInput}
                                    onInputChange={handlePositionInputChange}
                                    onChange={handlePositionChange}
                                    styles={selectStyles}
                                    noOptionsMessage={() => 'موردی یافت نشد - متن تایپ شده ثبت می‌شود'}
                                    filterOption={(option, input) =>
                                        option.label.toLowerCase().includes(input.toLowerCase())
                                    }
                                />
                            </div>

                        </div>
                        <div className="flex justify-center">
                            <button onClick={() => setShowModal(false)}><p className="text-[15px] font-IRANYekanBold ml-[23px]">بستن</p></button>
                            <button onClick={() => title == "ویرایش" ? editAdmin() : addAdmin()} className="h-[40px] w-[107px] bg-infinity-gradient rounded-[10px]"><p className="text-[15px] text-white font-IRANYekanBold">{buttonName}</p></button>
                        </div>
                    </div>
                </div>
                {showErrorModalStep1 ?
                    <>
                        <div
                            className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
                        >
                            <div className="relative w-[50%] lg:w-[50%] sm:w-[95%] my-5 mx-auto max-w-3xl">

                                <div className="border-0 rounded-lg p-2 shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">

                                    <div className="flex items-start justify-between p-4 border-b border-solid border-b-midGray rounded-t">
                                        <span className="text-base font-bold   text-red">
                                            درخواست اشتباه !
                                        </span>

                                    </div>

                                    <div className="relative px-4 py-1 flex-auto">
                                        <p className="my-4 text-black text-sm   leading-relaxed">
                                            {error}
                                        </p>
                                    </div>

                                    <div className="flex  items-center  justify-end border-solid border-slate-200 rounded-b">
                                        <Link
                                            className="text-white  mx-4 mb-2  rounded-md shadow-blueShadow  bg-infinity-gradient font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none ease-linear transition-all duration-150"
                                            type="button"
                                            onClick={() => setShowErrorModalStep1(false)}
                                        >
                                            فهمیدم
                                        </Link>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>

                    </>
                    : null
                }
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
    )
}

export default AddModalAdmin;
